import { IExclude, IEvent } from "@lib/store/src/calendar";
import { EBACnetDataTypes, IPopupEvent } from "./modal.types";
import { createTimePickerSelect } from "./modal.helpers";
import i18next from "i18next";

// <fw-timepicker id="time" interval=10 value="${event?.time?.hours}:${event?.time?.minutes}"></fw-timepicker>
export const getEditEventTemplate = (event: IEvent | IExclude) => `
    ${createTimePickerSelect( 
      `${event?.time?.hours}:${event?.time?.minutes}:${event?.time?.seconds || "00"}`
    )}
    <select
        id="select-type"
        placeholder="${i18next.t($ => $.scheduleBacnet.chooseDataType)}"
        value="${event?.dataType}"
    >
    </select>

    <div id="block-value"></div>
    
    <div class="delete-btn">✕</div>
`;

export const getOptionTemplateByType = (dataType: number, value?: string) => {
  switch (dataType) {
    case EBACnetDataTypes.NULL:
      return `
              <fw-input
                  id="event-value"
                  placeholder=""
                  required
                  disabled
              ></fw-input>
          `;
    case EBACnetDataTypes.BOOLEAN: {
      return ` 
              <div class="form-block align-center">
                  <fw-checkbox
                      id="event-value"
                      checked="${!!Number(value)}"
                  ></fw-checkbox> 
              </div>        
          `;
    }
    // case EBACnetDataTypes.TIME: {
    //   return `
    //         <fw-tooltip id="event-tooltip" content="" placement="right">
    //             <fw-timepicker id="event-value" interval=10 value="${value ?? ""}"></fw-timepicker>
    //         </fw-tooltip>
    //     `;
    // }
    // case EBACnetDataTypes.DATE: {
    //   return `
    //         <fw-tooltip id="event-tooltip" content="" placement="right">
    //             <fw-datepicker
    //                 id="event-value"
    //                 locale="ru"
    //                 placeholder="&nbsp;"
    //                 display-format="dd.MM.yy"
    //                 value="${value ?? ""}"
    //             >
    //             </fw-datepicker>
    //         </fw-tooltip>
    //     `;
    // }
    case EBACnetDataTypes.UNSIGNED_INTEGER:
    case EBACnetDataTypes.SIGNED_INTEGER:
    case EBACnetDataTypes.REAL:
    // case EBACnetDataTypes.OCTET_STRING:
    // case EBACnetDataTypes.BIT_STRING:
    // case EBACnetDataTypes.CHARACTER_STRING:
    case EBACnetDataTypes.DOUBLE: {
      return `
              <fw-tooltip id="event-tooltip" content="" placement="right">
                  <fw-input
                      id="event-value"
                      placeholder=""
                      value="${value ?? ""}"
                      required
                  ></fw-input>
              </fw-tooltip> 
          `;
    }

    case EBACnetDataTypes.ENUMERATION: {
        return `
            <fw-tooltip id="event-tooltip" content="" placement="right">
                <select
                    id="event-value"
                    placeholder="${i18next.t($ => $.scheduleBacnet.chooseDataType)}"
                >
                </select>
            </fw-tooltip> 
        
        `;
    }

    default: {
      return `
          <fw-tooltip id="event-tooltip" content="" placement="right">
              <fw-input
                  id="event-value"
                  placeholder=""
                  required
                  disabled
              ></fw-input>
          </fw-tooltip> 
      `;
    }
  }
};

export const getAddEventTemplate = () => `
    ${createTimePickerSelect()} 
    <select
        id="select-type"
        placeholder="${i18next.t($ => $.scheduleBacnet.chooseDataType)}"
    >
    </select>
    <div id="block-value">
        <fw-input
            placeholder=""
            required
            disabled
        ></fw-input>
    </div>
    <div class="delete-btn">✕</div>
`;

export const popupEvent = ({
  title,
  desc,
  primaryText,
  secondaryText,
}: IPopupEvent) => `
<style>  
    .popup-wrapper {
        padding: 10px;
        min-width: 400px;
        display: flex;
        flex-direction: column;
        gap: 8px;
    } 

    .popup-title {
        margin: 0;
    }

    .popup-content_delete {
        display: flex;
        align-items: center;
        gap: 4px;
    }

    .popup-footer {
        display: flex;
        justify-content: end;
        gap: 10px;
    }

    #close-icon {
        cursor: pointer;
    }

    #edit button {
      color: #fff;
      background: #345AA4;
    }
 
</style>

<div class="popup" style="background: #fff;">
    <div class="popup-wrapper">
        <h3 class="popup-title">${title ?? ""}</h3>

        <div class="popup-content popup-content_delete"> 
            <span>${desc ?? ""}</span>
        </div>
        
        <div class="popup-footer">
            <fw-button id="primary" color="primary"> ${
              primaryText ?? i18next.t($ => $.ok)
            } </fw-button>
            <fw-button id="secondary" color="secondary"> ${
              secondaryText ?? i18next.t($ => $.cancel)
            } </fw-button>
        </div>
    </div> 
</div>
`;
